module.exports = __webpack_public_path__ + "img/arrow-right.7b4c2b7c.svg";